import { render, staticRenderFns } from "./SquadraOfferta.vue?vue&type=template&id=06169484&scoped=true&"
import script from "./SquadraOfferta.vue?vue&type=script&lang=js&"
export * from "./SquadraOfferta.vue?vue&type=script&lang=js&"
import style0 from "./SquadraOfferta.vue?vue&type=style&index=0&id=06169484&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06169484",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/diego/Desktop/code/asta-live/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('06169484')) {
      api.createRecord('06169484', component.options)
    } else {
      api.reload('06169484', component.options)
    }
    module.hot.accept("./SquadraOfferta.vue?vue&type=template&id=06169484&scoped=true&", function () {
      api.rerender('06169484', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/SquadraOfferta.vue"
export default component.exports